class RestartRxInjectablePlan extends HTMLElement {
  connectedCallback() {
    this.plans=JSON.parse(this.querySelector('[data-plans]').textContent);
    this.form=this.closest('product-form-component');
    this.onForm=event=>{
      const input=event.target;
      const picker=input.closest?.('variant-picker');
      if(picker?.dataset.productId!==this.dataset.productId || input.dataset.fieldsetIndex!=='0' || input.type!=='radio')return;
      const target=input.value==='Injection'
        ? (this.dataset.medication==='semaglutide'?'50807940088041':'50807944970473')
        : this.dataset.oralVariant;
      event.stopImmediatePropagation();
      const url=new URL(window.location.href);url.searchParams.delete('option_values');url.searchParams.set('variant',target);
      window.location.assign(url.toString());
    };
    document.addEventListener('change',this.onForm,true);
    this.onVariant=event=>{
      if(String(event.detail?.data?.productId)===this.dataset.productId)
        this.update(String(event.detail?.resource?.id));
    };
    document.addEventListener('variant:update',this.onVariant);
    this.onChange=event=>{if(event.target.tagName==='SELECT')this.querySelector('input[value="prepaid"]').checked=true;this.renderPlan();};this.addEventListener('change',this.onChange);
    // Browsers can restore a selected radio after the component first renders.
    this.onPageShow=()=>window.requestAnimationFrame(()=>{if(this.isConnected)this.renderPlan();});
    window.addEventListener('pageshow',this.onPageShow);
    this.onStart=()=>this.renderPlan();
    this.querySelector('[data-injectable-start]').addEventListener('click',this.onStart);
    this.update(String(this.form?.querySelector('input[name="id"]')?.value));
    this.onPageShow();
  }
  disconnectedCallback(){document.removeEventListener('variant:update',this.onVariant);document.removeEventListener('change',this.onForm,true);this.removeEventListener('change',this.onChange);window.removeEventListener('pageshow',this.onPageShow);this.querySelector('[data-injectable-start]')?.removeEventListener('click',this.onStart);}
  update(variant){
    const injectable=variant&&variant!=='undefined'&&variant!==this.dataset.oralVariant;
    this.hidden=!injectable;
    const standard=this.form?.querySelector('[data-restartrx-standard-purchase]');
    // Oral visibility is owned by the existing white-label component.
    if(standard&&injectable)standard.hidden=true;
    const picker=document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
    for(const field of picker?.querySelectorAll('fieldset')??[]){
      if(field.querySelector('legend')?.textContent.trim()==='Supply')field.hidden=Boolean(injectable);
    }
    this.renderPlan();
  }
  renderPlan(){
    const cycles=Number(this.querySelector('select').value);
    const plan=this.plans.find(p=>p.cycles===cycles);
    const selected=this.querySelector('input[name$="-plan-type"]:checked')?.value;
    const summaryPlan=selected==='prepaid'?plan:this.plans.find(p=>p.cycles===12);
    this.querySelector('[data-prepaid-price]').textContent=(selected==='prepaid'?'':'From ')+summaryPlan.monthlyPrice;
    this.querySelector('[data-prepaid-savings]').textContent=`Save ${selected==='prepaid'?'':'up to '}${summaryPlan.savingsAmount} (${summaryPlan.savingsPercent}%)`;
    this.querySelector('.rrx-prepaid-detail').hidden=selected!=='prepaid';
    this.querySelector('[data-upfront]').textContent=plan.billingDisclosure;
    this.querySelector('[data-plan-detail]').textContent=plan.savings+' Cancel future renewals at any time.';
    this.querySelector('[data-price-lock]').hidden=selected==='one_time';
    const option=selected==='one_time'?'one_time':selected==='monthly'?'cycles_1':plan.key;
    const launch=new URL(`https://restartrx.com/apps/start-treatment/${this.dataset.medication}-injection`);
    launch.searchParams.set('purchase_option',option);
    const startLink=this.querySelector('[data-injectable-start]');
    if(window.__rrxShopifyUtmHandoff?.setLaunchHref)window.__rrxShopifyUtmHandoff.setLaunchHref(startLink,launch.toString());
    else startLink.href=launch.toString();
    this.querySelector('[data-billing-note]').textContent=selected==='one_time'
      ? 'One 4-week treatment supply. No automatic renewal.'
      : selected==='monthly' ? this.plans.find(p=>p.cycles===1).billingDisclosure : plan.billingDisclosure;
    this.querySelector('[data-billing-note]').hidden=selected==='prepaid';
  }
}
if(!customElements.get('rrx-injectable-plan'))customElements.define('rrx-injectable-plan',RestartRxInjectablePlan);
